// extracted by mini-css-extract-plugin
export var displayWordmark = "MiracleLogo-module--displayWordmark--429f1";
export var iconMain = "MiracleLogo-module--iconMain--98055";
export var iconSingleColor = "MiracleLogo-module--iconSingleColor--5945b";
export var isColored = "MiracleLogo-module--isColored--a0fc2";
export var isSingleColor = "MiracleLogo-module--isSingleColor--0a8a9";
export var wordmark = "MiracleLogo-module--wordmark--86f76";
export var wrapper = "MiracleLogo-module--wrapper--a5874";